import { render, staticRenderFns } from "./DesignList.vue?vue&type=template&id=259f09e0&scoped=true"
import script from "./DesignList.vue?vue&type=script&lang=js"
export * from "./DesignList.vue?vue&type=script&lang=js"
import style0 from "./DesignList.vue?vue&type=style&index=0&id=259f09e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259f09e0",
  null
  
)

export default component.exports